import type { HttpClient } from '@/lib/http/client.js'
import type { KeysetPage } from '@/types/audit/audit.type.js'
import type { ShopEvent, ShopEventSearch } from '@/types/shop-event/shop-event.type.js'

/**
 * `admin/shop-events`, verified against `shop-event-admin.controller.ts`.
 *
 * Read-only, and there is no write method here on purpose: events come from the Shopify
 * app through the shop surface. An operator inventing shop activity would make the log
 * worthless as a record of what the merchant actually did.
 */
export interface ShopEventService {
  search: (query: ShopEventSearch) => Promise<KeysetPage<ShopEvent>>
}

export function createShopEventService(http: HttpClient): ShopEventService {
  return {
    // `query` goes through the client's `buildUrl`, which drops `undefined` and `''` — an
    // empty filter must be absent, because the DTO validates whatever is present.
    search: (query) =>
      http.get<KeysetPage<ShopEvent>>('admin/shop-events', { query: { ...query } }),
  }
}
